import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
export function ComparisonSection() {
  return <section className="bg-muted py-16 sm:py-24" data-id="element-1">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <div className="text-center mb-12" data-id="element-3">
          <h2 className="text-3xl sm:text-4xl font-bold text-foreground" data-id="element-4">
            ¿Por Qué Elegir Trimora?
          </h2>
          <p className="mt-3 text-muted-foreground text-lg max-w-xl mx-auto" data-id="element-5">
            Una comparativa honesta para que tomes la mejor decisión.
          </p>
        </div>

        {/* Before/After images */}
        <div className="grid grid-cols-2 gap-4 max-w-lg mx-auto mb-12" data-id="element-6">
          <div className="aspect-[3/4] rounded-xl overflow-hidden border border-green-200 shadow-sm" data-id="element-7">
            <img src="https://cdn.magicpatterns.com/uploads/myi2429w61urcg6fBawDaH/imgi_27_1765695300-imgi_19_1760554606-227_-_Review_photos.png" alt="Antes de Trimora" className="w-full h-full object-cover" data-id="element-8" />
          </div>
          <div className="aspect-[3/4] rounded-xl overflow-hidden border border-green-200 shadow-sm" data-id="element-9">
            <img src="https://cdn.magicpatterns.com/uploads/9jVxMEZimf1GE4W686E1Ft/imgi_20_1765695302-imgi_14_1760554883-227_-_Funnel_Image_(11).png" alt="Después de Trimora" className="w-full h-full object-cover" data-id="element-10" />
          </div>
          <p className="col-span-2 text-center text-xs text-muted-foreground" data-id="element-11">
            Resultados individuales pueden variar.
          </p>
        </div>

        {/* Comparison Table */}
        <div className="bg-card rounded-2xl shadow-sm border border-border overflow-hidden" data-id="element-12">
          <div className="overflow-x-auto" data-id="element-13">
            <table className="w-full" data-id="element-14">
              <thead data-id="element-15">
                <tr className="border-b border-border" data-id="element-16">
                  <th className="text-left p-4 sm:p-6 text-foreground font-semibold text-sm sm:text-base w-2/5" data-id="element-17">
                    Característica
                  </th>
                  <th className="p-4 sm:p-6 text-center bg-green-600 text-white font-bold text-sm sm:text-base" data-id="element-18">
                    Trimora
                  </th>
                  <th className="p-4 sm:p-6 text-center text-muted-foreground font-semibold text-sm sm:text-base" data-id="element-19">
                    Dietas Extremas
                  </th>
                  <th className="p-4 sm:p-6 text-center text-muted-foreground font-semibold text-sm sm:text-base" data-id="element-20">
                    Pastillas Milagro
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-21">
                <tr className="border-b border-border" data-id="element-22">
                  <td className="p-4 sm:p-6 text-foreground text-sm sm:text-base" data-id="element-23">
                    Apoyo metabólico diario
                  </td>
                  <td className="p-4 sm:p-6 text-center bg-green-50" data-id="element-24">
                    <CheckIcon className="w-5 h-5 text-green-600 mx-auto" data-id="element-25" />
                  </td>
                  <td className="p-4 sm:p-6 text-center" data-id="element-26">
                    <XIcon className="w-5 h-5 text-muted-foreground mx-auto" data-id="element-27" />
                  </td>
                  <td className="p-4 sm:p-6 text-center" data-id="element-28">
                    <XIcon className="w-5 h-5 text-muted-foreground mx-auto" data-id="element-29" />
                  </td>
                </tr>
                <tr className="border-b border-border" data-id="element-30">
                  <td className="p-4 sm:p-6 text-foreground text-sm sm:text-base" data-id="element-31">
                    Sin extremos
                  </td>
                  <td className="p-4 sm:p-6 text-center bg-green-50" data-id="element-32">
                    <CheckIcon className="w-5 h-5 text-green-600 mx-auto" data-id="element-33" />
                  </td>
                  <td className="p-4 sm:p-6 text-center" data-id="element-34">
                    <XIcon className="w-5 h-5 text-muted-foreground mx-auto" data-id="element-35" />
                  </td>
                  <td className="p-4 sm:p-6 text-center" data-id="element-36">
                    <XIcon className="w-5 h-5 text-muted-foreground mx-auto" data-id="element-37" />
                  </td>
                </tr>
                <tr className="border-b border-border" data-id="element-38">
                  <td className="p-4 sm:p-6 text-foreground text-sm sm:text-base" data-id="element-39">
                    Fácil uso
                  </td>
                  <td className="p-4 sm:p-6 text-center bg-green-50" data-id="element-40">
                    <CheckIcon className="w-5 h-5 text-green-600 mx-auto" data-id="element-41" />
                  </td>
                  <td className="p-4 sm:p-6 text-center" data-id="element-42">
                    <XIcon className="w-5 h-5 text-muted-foreground mx-auto" data-id="element-43" />
                  </td>
                  <td className="p-4 sm:p-6 text-center" data-id="element-44">
                    <CheckIcon className="w-5 h-5 text-muted-foreground mx-auto" data-id="element-45" />
                  </td>
                </tr>
                <tr className="border-b border-border" data-id="element-46">
                  <td className="p-4 sm:p-6 text-foreground text-sm sm:text-base" data-id="element-47">
                    Enfoque sostenible
                  </td>
                  <td className="p-4 sm:p-6 text-center bg-green-50" data-id="element-48">
                    <CheckIcon className="w-5 h-5 text-green-600 mx-auto" data-id="element-49" />
                  </td>
                  <td className="p-4 sm:p-6 text-center" data-id="element-50">
                    <XIcon className="w-5 h-5 text-muted-foreground mx-auto" data-id="element-51" />
                  </td>
                  <td className="p-4 sm:p-6 text-center" data-id="element-52">
                    <XIcon className="w-5 h-5 text-muted-foreground mx-auto" data-id="element-53" />
                  </td>
                </tr>
                <tr data-id="element-54">
                  <td className="p-4 sm:p-6 text-foreground text-sm sm:text-base" data-id="element-55">
                    Garantía 90 días
                  </td>
                  <td className="p-4 sm:p-6 text-center bg-green-50" data-id="element-56">
                    <CheckIcon className="w-5 h-5 text-green-600 mx-auto" data-id="element-57" />
                  </td>
                  <td className="p-4 sm:p-6 text-center" data-id="element-58">
                    <XIcon className="w-5 h-5 text-muted-foreground mx-auto" data-id="element-59" />
                  </td>
                  <td className="p-4 sm:p-6 text-center" data-id="element-60">
                    <XIcon className="w-5 h-5 text-muted-foreground mx-auto" data-id="element-61" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>;
}